import apiClient from '../config/api';

const testimonialService = {
  // Get all testimonials
  getAll: async () => {
    try {
      const response = await apiClient.get('/api/testimonials');
      return response;
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      throw error;
    }
  },

  // Get pending testimonials (awaiting approval)
  getPending: async () => {
    try {
      // Use the stored admin token
      const adminToken = localStorage.getItem('admin_token');
      console.log('[TestimonialService] getPending - Admin token exists:', !!adminToken);
      
      if (!adminToken) {
        throw new Error('Admin token not found. Please login as admin again.');
      }

      console.log('[TestimonialService] Calling /api/testimonials/pending with stored admin token');
      const response = await apiClient.get('/api/testimonials/pending', {
        headers: {
          Authorization: `Bearer ${adminToken}`
        }
      });

      console.log('[TestimonialService] Successfully fetched pending testimonials');
      return response;
    } catch (error) {
      console.error('[TestimonialService] Error fetching pending testimonials:', error);
      throw error;
    }
  },

  // Create testimonial on behalf of customer
  createOnBehalf: async (data) => {
    try {
      const adminToken = localStorage.getItem('admin_token');
      if (!adminToken) {
        throw new Error('Admin token not found. Please login as admin again.');
      }

      const response = await apiClient.post('/api/testimonials/on-behalf', {
        customerEmail: data.customerEmail,
        customerName: data.customerName,
        text: data.text,
        rating: data.rating
      }, {
        headers: {
          Authorization: `Bearer ${adminToken}`
        }
      });
      return response;
    } catch (error) {
      console.error('Error creating testimonial:', error);
      throw error;
    }
  },

  // Update testimonial
  update: async (id, data) => {
    try {
      const response = await apiClient.put(`/api/testimonials/${id}`, {
        text: data.text,
        rating: data.rating
      });
      return response;
    } catch (error) {
      console.error('Error updating testimonial:', error);
      throw error;
    }
  },

  // Approve testimonial (called from email link)
  approve: async (token) => {
    try {
      const response = await apiClient.post('/api/testimonials/approve', { token });
      return response;
    } catch (error) {
      console.error('Error approving testimonial:', error);
      throw error;
    }
  },

  // Delete testimonial
  delete: async (id) => {
    try {
      const adminToken = localStorage.getItem('admin_token');
      if (!adminToken) {
        throw new Error('Admin token not found. Please login as admin again.');
      }

      const response = await apiClient.delete(`/api/testimonials/${id}`, {
        headers: {
          Authorization: `Bearer ${adminToken}`
        }
      });
      return response;
    } catch (error) {
      console.error('Error deleting testimonial:', error);
      throw error;
    }
  },

  // Send approval email
  sendApprovalEmail: async (testimonialId) => {
    try {
      const response = await apiClient.post(`/api/testimonials/${testimonialId}/send-approval`);
      return response;
    } catch (error) {
      console.error('Error sending approval email:', error);
      throw error;
    }
  }
};

export default testimonialService;
